import { render, staticRenderFns } from "./DocumentEditDialog.vue?vue&type=template&id=d6ab6064&"
import script from "./DocumentEditDialog.vue?vue&type=script&lang=js&"
export * from "./DocumentEditDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports